import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { HomePage } from './home.page';
import { AuthGuardService } from '../../services/auth-guard.service';
import { DashboardStatsResolver } from '../../services/statement/dashboardStats';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        resolve: {
          // stats: DashboardStatsResolver,
        },
        component: HomePage,
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuardService],
      },
    ]),
  ],
  declarations: [HomePage],
  providers: [DashboardStatsResolver],
})
export class HomePageModule {}
